<template>
  <div class="demoNotice demoNoticeCenter">
      <b-modal title="Visual Changes" v-model="optionsData.show" size="xl"  id="modalPopover"  hide-footer>
          <b-dropdown size="sm" id="dropdown-left" :text="selectedDevice.title" class="m-2" style="position:absolute;right:0px;top:2px">
              <b-dropdown-item v-for="device in activeSite.devices" href="#" @click="setDevice(device)">{{device.title}}</b-dropdown-item>
          </b-dropdown>

          <div>
              <a :href="page.url" target="_blank">{{page.url}}</a><br>
              <small>
                  <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }"  v-b-tooltip.hover title="Page Details"><i class="fa fa-eye"></i> Page Details</router-link>
              </small>
          </div>

          <div style="text-align:center;border:0px solid blue;position:relative">
              <div style="position:absolute;left:150px"><b-badge variant="info">{{page.dateBefore | moment('D MMM, h:mm a')}}</b-badge></div>
              <div style="position:absolute;right:150px"><b-badge variant="info">{{page.dateAfter | moment('D MMM, h:mm a')}}</b-badge></div>
          <b-form-checkbox v-if="boxesBefore.length > 0 || boxesAfter.length > 0"
                  id="checkbox-1"
                  v-model="highlightChanges"
                  name="checkbox-1"
                  size="lg"
          >
              Highlight Changes
          </b-form-checkbox>
              <b-alert style="display:inline-block" show v-else variant="success">No Changes Detected</b-alert>
          </div>

           <div style="width:100%;text-align:center">
               <div style="display:inline-block">
          <vue-image-compare :before="imageBefore" :boxesBefore="boxesBefore" :boxesAfter="boxesAfter"
                         :after="imageAfter" :width="imageWidth" :height="imageHeight" :highlight="highlightChanges"
                   >
              <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
              <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
          </vue-image-compare>
               </div>
          </div>
      </b-modal>

  </div>
</template>
<script>
  import Widget from '@/components/Widget/Widget';
  import VueImageCompare from '@/components/ChangeViewer/VueImageCompare';
  import { mapState } from "vuex";
  import gql from "graphql-tag";
  export default {
  name: 'Loader',
  components: { Widget, VueImageCompare },
  props: {
    options: {type: Object, default: function(){ return {
        show: false,
        path: '',
        device: 'chrome',
        page: 0
      }}},
  },
  data(){
    return {
      completed: false,
      highlightChanges: true,
      optionsData: this.options,
      imageBefore: '',
      imageAfter: '',
      imageWidth: 800,
      imageHeight: 500,
      selectedDevice: {},

      parentCrawlId: 0,
      boxesBefore: [],
      boxesAfter: [],
      page: {},
    }
  },
    apollo: {
      changes:{
        query(){
          return gql`query getChanges($pageId: Int!, $device: String!){

          changes:websites_crawledpage(where: {id: {_eq: $pageId}}){
            id
            path
            url
            crawl_id
            crawl_date
            websites_devicerenders(where: {device_id: {_eq: $device}}){
                id
                screenshots
            }
            websites_diffs(where: {type: {_eq: 17}, websites_devicerender:{device_id:{_eq: $device}}}){
                id
                ratio
                type
                data
            }
            parent_page{
                id
                path
                url
                crawl_id
                crawl_date
                websites_devicerenders(where: {device_id: {_eq: $device}}){
                    id
                    screenshots
                }
                websites_diffs(where: {type: {_eq: 17}, websites_devicerender:{device_id:{_eq: $device}}}){
                    id
                    ratio
                    type
                    data
                }
            }
          }
        }`
        },
        variables(){
          return {
            pageId: parseInt(this.optionsData.page, 10),
            device: this.selectedDevice.id || this.optionsData.device,
          }
        },
          skip () {
            return !this.optionsData.page
          },
          result (data) {
            this.setDevice(this.activeSite.devices.find((d) => { return d.id === (this.selectedDevice.id || this.optionsData.device); }))

            this.loading = true;
            let page = data.data.changes[0];
            let parentPage = data.data.changes[0].parent_page;

            if (!parentPage){
              this.boxesBefore = [];
              this.boxesAfter = [];
              this.page.url = page.url;
              this.page.dateBefore = page.crawl_date;
              this.page.dateAfter = '';
              this.page.path = page.path;

              let originalWidth = page.websites_devicerenders[0].screenshots.full.screenshot.width;
              let height1 = page.websites_devicerenders[0].screenshots.full.screenshot.height;

              let ratio = Math.min(originalWidth, 800) / originalWidth;
              this.imageWidth = originalWidth * ratio;
              this.imageHeight = height1 * ratio;

              let transform = `?tr=w-${this.imageWidth},h-${this.imageHeight},cm-pad_resize,bg-F3F3F3,fo-top`;
              this.imageBefore = page.websites_devicerenders[0].screenshots.full.screenshot.url+transform;
              this.imageAfter = this.imageBefore;
              return
            }

            this.page.url = page.url;
            this.page.dateBefore = parentPage.crawl_date;
            this.page.dateAfter = page.crawl_date;
            this.page.path = page.path;

            let originalWidth = page.websites_devicerenders[0].screenshots.full.screenshot.width;
            let height1 = page.websites_devicerenders[0].screenshots.full.screenshot.height;
            let height2 = parentPage.websites_devicerenders[0].screenshots.full.screenshot.height;

            let ratio = Math.min(originalWidth, 800) / originalWidth;
            this.imageWidth = originalWidth * ratio;
            this.imageHeight = Math.max(height1, height2) * ratio;

            let transform = `?tr=w-${this.imageWidth},h-${this.imageHeight},cm-pad_resize,bg-F3F3F3,fo-top`;
            this.imageBefore = parentPage.websites_devicerenders[0].screenshots.full.screenshot.url+transform;
            this.imageAfter = page.websites_devicerenders[0].screenshots.full.screenshot.url+transform;

            this.boxesBefore = [];
            this.boxesAfter = [];
            for (let diff of page.websites_diffs){

              for (let entry of diff.data){
                this.boxesAfter.push({
                  select:entry.box.select,
                  x: Math.round(entry.box.x * this.imageWidth / originalWidth),
                  y: Math.round(entry.box.y * this.imageWidth / originalWidth),
                  width: Math.round(entry.box.width * this.imageWidth / originalWidth),
                  height: Math.round(entry.box.height * this.imageWidth / originalWidth),
                  level: entry.box.level,
                  type: entry.type,
                });
                if (!(entry.parent && entry.parent.level)){
                  continue;
                }
                this.boxesBefore.push({
                  select:entry.parent.select,
                  x: Math.round(entry.parent.x * this.imageWidth / originalWidth),
                  y: Math.round(entry.parent.y * this.imageWidth / originalWidth),
                  width: Math.round(entry.parent.width * this.imageWidth / originalWidth),
                  height: Math.round(entry.parent.height * this.imageWidth / originalWidth),
                  level: entry.parent.level,
                  type: entry.type,
                })
              }
            }
          },

        },


    },
  methods: {
    setDevice(device) {
      this.selectedDevice = device;
    },
  },
  computed: {
    ...mapState({  user: "user", activeSite: "activeSite" }),
  },
  mounted() {
  },
}
</script>

<style src="./ChangeViewer.scss" lang="scss"/>
